module.exports = __webpack_public_path__ + "img/8-white.6f3df75c.png";